import * as R from 'ramda';
import React, {useState} from 'react';

import {translate} from 'iss/strings';
import styles from 'iss/styles/TaggingInput.styl';
import CloseButton from 'iss/widgets/bootstrap/CloseButton';

export function TaggingInput({id, tags, formatTag, parseTag, onChange, placeholder}) {
  return <div className={"form-control "+styles.taggingInput} id={id}>
    <ChosenTags tags={tags} formatTag={formatTag} onRemoveTag={tag => onChange(R.reject(R.equals(tag), tags))}/>
    <TagAddingInput placeholder={placeholder} parseTag={parseTag} updateTags={updater => onChange(updater(tags))} />
  </div>;
}

function ChosenTags({tags, formatTag, onRemoveTag}) {
  return <React.Fragment>
    {tags.map(tag =>
      <div className="label label-primary" key={tag}>
        {formatTag(tag)}
        <CloseButton onClick={() => onRemoveTag(tag)} aria-label={translate('common.remove')} />
      </div>
    )}
  </React.Fragment>;
}

function TagAddingInput({parseTag, updateTags, placeholder}) {
  const [text, setText] = useState('');
  const removeLastTag = () => updateTags(tags => tags.length > 0 ? R.dropLast(1, tags) : []);

  function attemptToAddTag() {
    const tag = parseTag(text);
    if (tag) {
      const addTagIfNotExists = R.compose(R.uniq, R.append(tag));
      updateTags(addTagIfNotExists);
      setText("");
    }
  }
  function onChange(value) {
    //Pasting heuristic. Need to test this
    const textPasted = value.length > text.length + 1;
    if (!textPasted) {
      setText(value);
      return;
    }

    const parts = value.split(separatorChars);
    const parsedTags = R.takeWhile(parseTag, parts).map(parseTag);
    const remainingParts = R.drop(parsedTags.length, parts);

    const addTagsIfNotExists = R.compose(R.uniq, R.concat(parsedTags));
    updateTags(addTagsIfNotExists);
    setText(remainingParts.join(", "));
  }

  return <input type="text" value={text}
    placeholder={placeholder}
    onChange={({target}) => onChange(target.value)}
    onBlur={attemptToAddTag}
    onKeyDown={(e) => {
      const {key} = e;
      if (key == "Backspace" && text == "") {
        removeLastTag();
      }
      if (shouldParseTags(key, text)) {
        attemptToAddTag();
        e.preventDefault();
      }
  }}/>;
}

function shouldParseTags(key, text) {
  return key == "Enter" || (key == "Tab" && text != "") || key.match(separatorChars);
}

const separatorChars = /[ ,]+/;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/input/TaggingInput.jsx